import { css } from 'styled-components';
export const preView10 = '0px 0px 10% 0px';
export const inViewMargin = '0px 0px -35% 0px';
export const inView30 = '0px 0px -30% 0px';
export const inView20 = '0px 0px -20% 0px';
export const inView50 = '0px 0px -50% 0px';
export const inView75 = '0px 0px -75% 0px';
export const inView100 = '0px 0px -100% 0px';
export const cubicEaseOut = `cubic-bezier(0.33, 1, 0.68, 1)`;
export function fadeUp(params) {
    return css `
    opacity: 0;
    transform: translateY(20px);
    transition: opacity, transform;
    transition-delay: ${params.delay}s;
    transition-duration: ${params.duration}s;
    transition-timing-function: ${cubicEaseOut};

    [data-animate='true'] & {
      opacity: 1;
      transform: translateY(0px);
    }
  `;
}
export function inViewFade(params) {
    return css `
    transition: opacity;
    transition-delay: ${params.delay}s;
    transition-duration: ${params.duration}s;
    transition-timing-function: ${cubicEaseOut};

    [data-inview='false'] & {
      opacity: 0;
    }

    [data-inview='true'] & {
      opacity: 1;
    }
  `;
}
export function inViewFadeUp(params) {
    return css `
    transition: opacity, transform;
    transition-delay: ${params.delay}s;
    transition-duration: ${params.duration}s;
    transition-timing-function: ${cubicEaseOut};

    [data-inview='false'] & {
      opacity: 0;
      transform: translateY(20px);
    }

    [data-inview='true'] & {
      opacity: 1;
      transform: translateY(0);
    }
  `;
}
export const shouldAnimate = (innerCss) => {
    return css `
    @media (prefers-reduced-motion: no-preference) {
      ${innerCss}
    }
  `;
};
export const transition = (properties, duration = 0.35, timing = cubicEaseOut) => {
    return shouldAnimate(css `
    transition: ${properties};
    transition-duration: ${typeof duration === 'string' ? duration : `${duration}s`};
    transition-timing-function: ${timing};
    will-change: ${properties};
  `);
};
export function inViewChangeColour(params, initialColor, endColor) {
    return css `
    transition: color;
    transition-delay: ${params.delay}s;
    transition-duration: ${params.duration}s;
    transition-timing-function: ${cubicEaseOut};

    [data-inview='false'] & {
      color: ${initialColor};
    }

    [data-inview='true'] & {
      color: ${endColor};
    }
  `;
}
